/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcestabfiles2Inputs */

const en_sourcestabfiles2 = /** @type {(inputs: Sourcestabfiles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaded files`)
};

const pt_sourcestabfiles2 = /** @type {(inputs: Sourcestabfiles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ficheiros carregados`)
};

/**
* | output |
* | --- |
* | "Uploaded files" |
*
* @param {Sourcestabfiles2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcestabfiles2 = /** @type {((inputs?: Sourcestabfiles2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcestabfiles2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcestabfiles2(inputs)
	return pt_sourcestabfiles2(inputs)
});
export { sourcestabfiles2 as "sourcesTabFiles" }